/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Saveasdraft2Inputs */

const en_saveasdraft2 = /** @type {(inputs: Saveasdraft2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save as draft`)
};

const de_saveasdraft2 = /** @type {(inputs: Saveasdraft2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Als Entwurf speichern`)
};

/**
* | output |
* | --- |
* | "Save as draft" |
*
* @param {Saveasdraft2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const saveasdraft2 = /** @type {((inputs?: Saveasdraft2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Saveasdraft2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_saveasdraft2(inputs)
	return de_saveasdraft2(inputs)
});
export { saveasdraft2 as "saveAsDraft" }